import React from 'react';

import {
  ApprovalTypeName,
  ReturnAuthorizationsActivity_TabBarDocument,
  useAcceptReturnAuthorizationMutation
} from 'generated/graphql';



export function useAcceptReturnAuthorization(returnAuthorizationId: string, storeId?: string) {
  const [fnMutate, tuple] = useAcceptReturnAuthorizationMutation({
    awaitRefetchQueries: true,
    refetchQueries: [{
      query: ReturnAuthorizationsActivity_TabBarDocument,
      variables: { storeId }
    }]
  });

  const fnWrappedMutate = React.useCallback(
    async (approvalTypeName: ApprovalTypeName) => {
      await fnMutate({
        variables: {
          returnAuthorizationId,
          approvalTypeName
        }
      });
    },
    [fnMutate, returnAuthorizationId]
  );

  return React.useMemo(
    () => [
      fnWrappedMutate,
      {
        ...tuple,
        data: null
      }
    ] as const,
    [
      fnWrappedMutate,
      tuple
    ]
  );
}
